enum InvolvementType {
  CausalDamage = 'CausalDamage',
  ConsequentialDamage = 'ConsequentialDamage',
  CausalAndConsequentialDamage = 'CausalAndConsequentialDamage',
}

export default InvolvementType;
